// third-party
import {FormattedMessage} from 'react-intl';

// project import
// Dashboard Menu Items are coming from Mock Api
import {useSelector} from 'layout/mantis/store';

// assets
import {DashboardOutlined, GoldOutlined} from '@ant-design/icons';

// type
import {NavItemType} from 'layout/mantis/types/MenuType';

const icons = {
    dashboardOutlined: DashboardOutlined,
    goldOutlined: GoldOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

export const DashboardMenu = () => {
    const {menuDashboard} = useSelector((state) => state.menu);

    const SubChildrenLis = (SubChildrenLis: NavItemType[]) => {
        return SubChildrenLis?.map((subList: NavItemType) => {
            return {
                ...subList,
                title: <FormattedMessage id={ `${ subList.title }` }/>,
                // @ts-ignore
                icon: icons[subList.icon]
            };
        });
    };

    const menuList = (subList: NavItemType) => {
        let list: NavItemType = {
            ...subList,
            title: <FormattedMessage id={ `${ subList.title }` }/>,
            // @ts-ignore
            icon: icons[subList.icon]
        };

        if (subList.type === 'collapse') {
            list.children = SubChildrenLis(subList.children!);
        }
        return list;
    };
    const ChildrenList: NavItemType[] | undefined = menuDashboard?.children?.map((subList: NavItemType) => {
        return menuList(subList);
    });

    const dashboardList: NavItemType = {
        ...menuDashboard,
        title: <FormattedMessage id={ `${ menuDashboard.title }` }/>,
        // @ts-ignore
        icon: icons[menuDashboard.icon],
        children: ChildrenList
    };

    return dashboardList;
};
